import React, { FC, useMemo } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { Link, View } from "@lookiero/aurora";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { style as returnInfoStyle } from "./ReturnInfo.style";

interface ReturnInfoProps {
  readonly showRefundNotification: boolean;
  readonly showReturnInstructions: boolean;
  readonly faqUrl: string;
  readonly isCancelled: boolean;
  readonly style?: StyleProp<ViewStyle>;
  readonly onPressReturnInstructions: () => void | undefined;
}

const ReturnInfo: FC<ReturnInfoProps> = ({
  showRefundNotification,
  showReturnInstructions,
  isCancelled,
  faqUrl,
  style: customStyle,
  onPressReturnInstructions,
}) => {
  const style = useMemo(() => returnInfoStyle(), []);

  const orderHelpReturnText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.ORDER_HELP_RETURN_TEXT,
  });
  const orderHelpText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.ORDER_HELP_TEXT,
  });
  const orderShowReturnInstructionsText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.ORDER_SHOW_RETURN_INSTRUCTIONS,
  });
  const orderHelpReturnLinkText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.ORDER_HELP_RETURN_LINK,
  });
  const orderHelpLinkText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.ORDER_HELP_LINK,
  });

  return (
    <View style={customStyle}>
      <Text level={3} style={style.instructionsTitle}>
        {showRefundNotification ? orderHelpReturnText : orderHelpText}
      </Text>
      {showReturnInstructions ? (
        <Link level={3} style={style.returnInstructions} action underlined onPress={onPressReturnInstructions}>
          {orderShowReturnInstructionsText}
        </Link>
      ) : null}
      {!isCancelled ? (
        <Link href={faqUrl} level={3} style={style.helpLink} action underlined>
          {showRefundNotification ? orderHelpReturnLinkText : orderHelpLinkText}
        </Link>
      ) : null}
    </View>
  );
};

export { ReturnInfo };
